"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.run = void 0;
const run = (callback) => callback();
exports.run = run;
